import { BedayaAction } from '../../types/BedayaAction';
import { EcwidSettings } from '../../types/EcwidSettings';
import { GET_SETTINGS, PUT_SETTINGS } from '../actions/common_actions';

export interface IEcwidState {
  settings: EcwidSettings;
  isFetching: boolean;
  error: any;
}

const initialState: IEcwidState = {
  settings: {
    order: {}
  },
  isFetching: false,
  error: '',
};

export default function reducer(state: IEcwidState = initialState, action: BedayaAction): IEcwidState {
  switch (action.type) {
    case GET_SETTINGS.REQUEST:
    case PUT_SETTINGS.REQUEST:
      if (['ecwid'].includes(action.data.system)) {
        return {
          ...state,
          isFetching: true,
        };
      }
      return state;
    case PUT_SETTINGS.SUCCESS:
      if (['ecwid'].includes(action.data.system)) {
        return {
          ...state,
          settings: action.data.data,
          isFetching: false,
        };
      }
      return state;
    case GET_SETTINGS.SUCCESS:
      if (['ecwid'].includes(action.data.system)) {
        return {
          ...state,
          settings: action.data.data,
          isFetching: false,
        };
      }
      return state;
    default:
      return state;
  }
}
